import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=17b74d76&"
import script from "./Dashboard.vue?vue&type=script&lang=js&"
export * from "./Dashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1983107846/src/bitbucket.org/atsuboi/chatbot/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17b74d76')) {
      api.createRecord('17b74d76', component.options)
    } else {
      api.reload('17b74d76', component.options)
    }
    module.hot.accept("./Dashboard.vue?vue&type=template&id=17b74d76&", function () {
      api.rerender('17b74d76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Dashboard/Dashboard.vue"
export default component.exports